'use strict';

var React = require('react'),
    config = require('config'),
    AnalyticsSources = require('../constants/AnalyticsSources'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    AboutCoverSection = require('../organisms/AboutCoverSection'),
    ShortSignUp = require('../molecules/ShortSignUp'),
    ShortLogin = require('../molecules/ShortLogin'),
    Link = require('../atoms/Link'),
    Icon = require('../atoms/Icon'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

var AboutForm = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    onLoginClick: React.PropTypes.func.isRequired,
    hideAboutLink: React.PropTypes.bool
  },

  className: 'Modal-body',

  getCSSModifiers: function () {
    return ['about'];
  },

  render: function () {
    return (
      <div className={this.getClassName()}>
        <div onTouchTap={this.props.onCloseClick}
             className='Modal-close'>
          <Icon name='cross' size='small' mode='stroke' />
        </div>

        <div>
          <AboutCoverSection layout='banner'>
            {this.renderAboutFooter()}
          </AboutCoverSection>
        </div>

        <div className='Modal-content Modal-content--stickToBottom'>
          {config.signUpEnabled ?
          <ShortSignUp source={AnalyticsSources.ABOUT_FORM} />
          :
          <ShortLogin source={AnalyticsSources.ABOUT_FORM} />
          }
        </div>

        {this.renderFooter()}
      </div>
    );
  },

  renderAboutFooter: function () {
    if (this.props.hideAboutLink) {
      return;
    }

    return (
      <Link color='light'
            to='about'
            underline='never'
            opaque
            bold>
        Learn More
      </Link>
    );
  },

  renderFooter: function () {
    return (
      <div className='Modal-footer Modal-center'>
        {config.signUpEnabled &&
        <span className='Modal-footerText'>
          <small>We value your privacy and won’t post anything on your behalf without your permission.</small>
          <br /><br />
          Already have an account?
          {' '}
          <Link onClick={this.props.onLoginClick}
                color='green'
                bold>
            Log In
          </Link>.
        </span>
        }
      </div>
    );
  }
});

module.exports = AboutForm;



/** WEBPACK FOOTER **
 ** ./modals/AboutForm.jsx
 **/